import { render, staticRenderFns } from "./PaymentsIcons.vue?vue&type=template&id=672b3946&scoped=true"
import script from "./PaymentsIcons.vue?vue&type=script&lang=js"
export * from "./PaymentsIcons.vue?vue&type=script&lang=js"
import style0 from "./PaymentsIcons.vue?vue&type=style&index=0&id=672b3946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b3946",
  null
  
)

export default component.exports